const DITypes = {
  JsonRpcDispatcher: Symbol('DmPortalJsonRpcDispatcher'),
  DispatcherFactory: Symbol('DmPortalDispatcherFactory'),
  AdapterFactory: Symbol('DmPortalAdapterFactory'),
};

export default DITypes;
